export default "skymp5-front/9565a852da2b9f6e0577f5bc7b41ed97.png";